






import {Component, Prop, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";

@Component({
    components: {
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class DialogWrapper extends Vue {
    @Prop() private title!: string;
}
